<template>
    <span class="tag" :style="style">
        <slot></slot>
    </span>
</template>
<script>
export default {
    name: 'tag',
    data() {
        return {}
    },
    props: {
        color: [String],
        bgColor: [String],
        noRadius: Boolean
    },
    computed: {
        style() {
            let style = {}
            if (this.color) style.color = this.color
            if (this.bgColor) style.backgroundColor = this.bgColor
            if (this.noRadius) style.borderRadius = 0
            return style
        }
    }
}
</script>
<style lang="scss" scoped>
@import '../../../assets/css/px2rem.scss';
@import '../../../assets/css/colors.scss';
.tag {
    display: inline-block;
    padding: 0 px2rem(4);
    height: px2rem(16);
    line-height: px2rem(16);
    font-size: px2rem(12);
    color: $orange;
    margin: 0 px2rem(6) 0 0;
    border: px2rem(1) solid $orange;
    border-radius: px2rem(4);
    box-sizing: border-box;
    white-space: nowrap;
}
</style>

